module.exports = __webpack_public_path__ + "media/1.76b9b0b5.mp3";